import { c as _c } from "react/compiler-runtime";
import { IconTag } from '@xefi/x-react/icons';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SearchFilter } from '@/components/SearchFilter';
import { useStatusesQuery } from '@/hooks/useStatusesQuery';
import type { Filter } from '@/models/common';
type SurveyFilterProps = {
  filters: Filter[];
  setFilters: (filters: Filter[]) => void;
  resetToken?: number;
};
export const SurveyFilter = t0 => {
  const $ = _c(17);
  const {
    setFilters,
    resetToken
  } = t0;
  const {
    t
  } = useTranslation();
  const {
    data: t1
  } = useStatusesQuery();
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const statuses = t2;
  let t3;
  let t4;
  if ($[2] !== statuses || $[3] !== t) {
    let t5;
    if ($[5] !== t) {
      t5 = status_0 => ({
        id: status_0.label,
        name: t(`survey.status.${status_0.label}`)
      });
      $[5] = t;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    t4 = statuses.filter(_temp).map(t5);
    $[2] = statuses;
    $[3] = t;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  t3 = t4;
  const statusItems = t3;
  const extractSelectedIds = _temp2;
  let t5;
  if ($[7] !== setFilters) {
    t5 = filter_0 => {
      const selectedIds = extractSelectedIds(filter_0);
      if (selectedIds.size === 0) {
        return setFilters([{
          field: "status.label",
          operator: "in",
          value: ["draft", "open", "paused"]
        }]);
      }
      setFilters([{
        field: "status.label",
        operator: "in",
        value: Array.from(selectedIds)
      }]);
    };
    $[7] = setFilters;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const handleStatusSelection = t5;
  const makeFilter = _temp3;
  let t6;
  if ($[9] !== t) {
    t6 = t("status", {
      ns: "common"
    }) ?? "Status";
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <IconTag size={16} />;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== handleStatusSelection || $[13] !== resetToken || $[14] !== statusItems || $[15] !== t6) {
    t8 = <SearchFilter className="w-40" placeholder={t6} selectionIcon={t7} items={statusItems} resetToken={resetToken} isFetching={false} fetchNextPage={_temp4} hasNextPage={false} setSearch={_temp5} setFilter={handleStatusSelection} makeFilter={makeFilter} />;
    $[12] = handleStatusSelection;
    $[13] = resetToken;
    $[14] = statusItems;
    $[15] = t6;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};
function _temp(status) {
  return status.label !== "closed";
}
function _temp2(filter) {
  if (!filter?.value) {
    return new Set();
  }
  const value = Array.isArray(filter.value) ? filter.value : [filter.value];
  return new Set(value.map(String));
}
function _temp3(ids) {
  return {
    field: "status.label",
    operator: "in",
    value: ids.length === 0 ? ["draft", "open", "paused"] : ids
  };
}
function _temp4() {}
function _temp5() {}